import React,{Component} from 'react';
import Select from 'react-select';
import { Button, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import * as actionCreators from '../../modules/actions/index';
import * as url from '../../utils/url';
import axios from '../../axios';
import Loading from '../../hoc/Loading/Loading';
import orderBy from 'lodash/orderBy'

class SelectEnterpriseIndustry extends Component {
  constructor(props) {
    super(props);
     this.state = {
       industry: null,
       industryOptions: []
     }
  }

  componentDidMount(){
    window.scrollTo(0, 0);
    this.getIndustries();
  }

  // Get Industries
  getIndustries = () => {
      axios.get(url.getIndustryList)
      .then(response => {
        let {industry} = this.state;
        let industryOptions = response.data.data;
        console.log(industryOptions)
        if(this.props.user.organizationId && this.props.user.organizationId.industry) {
          let foundUserOrgIndustry = industryOptions.filter(industry => industry._id === this.props.user.organizationId.industry); 
          if(foundUserOrgIndustry.length > 0) {
            industry = foundUserOrgIndustry[0];
          }
        }
        industryOptions = orderBy(industryOptions, 'name', 'asc')
        this.setState({industryOptions, industry});
      })
      .catch(error => {
        // console.log('get industries Error');
        this.setState({industryOptions: []});
      })
  }

  // Set Organization industry
  setIndustryForOrganization = () => {
    let {industry} = this.state;
    axios.put(url.updateIndustryForOrganization,{industry: industry._id}).then(({data}) => {
      this.props.onIndustryChangeSuccess(industry._id);
      // this.props.history.push('/setup/org-chart');
      // org-overview
      this.props.history.push('/setup/org-overview');
    })
  }

  render(){
    let {industryOptions, industry} = this.state;
    return(
      <div className="page-title-box">
        <div className="title-text">
          Enterprise Industry
        </div>
        <hr className="separator-line" />
        <div className="setup-content">
          Please select the industry your enterprise operates in. You can begin to type your industry name, 
          or select from the drop down listing of level 3 North American Industry Classification System 
          (NAICS) industries.
        </div>
        <Row className=" mt2em">
          <Col sm={{ size: '2' }} style={{textAlign:'right'}}>
            Industry
          </Col>
          <Col sm={{ size: '8' }}>
            <Select
                placeholder={"Select industry..."}
                value={industry}
                onChange={(industry) => this.setState({industry})}
                options={industryOptions}
                valueKey="_id" labelKey="name" 
            />
          </Col>
        </Row>
        <Row className="mt2em">
            <Col sm={{ size: '3', offset: 0 }}>
                <Button
                    className="float-right continueBtn ml10 w100"
                    onClick={this.setIndustryForOrganization}
                    disabled={industry===null}
                    >
                    <span className="continueBtnTxt">
                        Continue <span className="ml10 flaticon-next" />
                    </span>
                </Button>
            </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user.profile
  }
}

const mapDispatchToProps = dispatch => {
	return {
		onIndustryChangeSuccess: (data) => dispatch(actionCreators.industryChangeSuccess(data))
	}
}
 
export default connect(mapStateToProps,mapDispatchToProps)(Loading(SelectEnterpriseIndustry, axios));